module.exports = __webpack_public_path__ + "770b6ac40a029dbe76fee132c942e015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/hochformat/08.jpg
// module id = 145
// module chunks = 0